import { customSurveyForm } from "@hardware/Services/ContactUsService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

const capitalize = (word: string) => word[0].toUpperCase() + word.slice(1);

export const PopulateApiParameter: HandlerType = props => {
    const states = props.getState() as any;
    const state = states.surveyForm as any;

    const formData = {
        emailTo: props.parameter.emailRecipients,
    } as any;

    for (const key in state.fieldValues) {
        const value = state.fieldValues[key];
        if (value) {
            formData[capitalize(key)] = value;
        }
    }

    props.apiParameter = {
        emailTo: props.parameter.emailRecipients,
        AuthKey: formData["CompanyName"] + formData["FirstName"],
        ...formData,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await customSurveyForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitSurveyForm = createHandlerChainRunner(chain, "SurveyForm");
export default submitSurveyForm;
